import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import * as Template from "../../templates";


export default () => {

  const moduleName = "businesses";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [
    location.search,
    appReducer.businesses_destroy,
    appReducer.businesses_publish,
    appReducer.businesses_unpublish,
  ]);

  useEffect(() => {
    if (appReducer.businesses_list != undefined) {
      setRows(appReducer.businesses_list.data)
      setTotalPages(appReducer.businesses_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'وب‌سایت',
      selector: row => row.website,
    },
    {
      name: 'لوگو',
      selector: row => row.logo_full ? <img className="w-24 mt-4" src={row.logo_medium_full} /> : "-"
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <div>
    <Template.Filter moduleName={moduleName}>
      <Template.Input
        label="نام"
        placeholder="نام"
        name="name"
        type="text"
      />
      <Template.Input
        label="شناسه"
        placeholder="شناسه"
        name="id"
        type="text"
      />
      <Template.SingleSelect
      placeholder="انتخاب وضعیت"
        withLabel={true}
        default={0}
        name="state"
        options={[
          {
            value: "active",
            label: "فعال",
          },
          {
            value: "deactive",
            label: "غیرفعال",
          },
        ]}
      />
    </Template.Filter>
    <Template.Table count={totalPages} columns={columns} data={rows} />
  </div>
};
